import { Box } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import { MonitorOverview } from './overview/MonitorOverview';
import { PiprPage } from './pipr/PiprPage';

export function MonitorView() {
    return (
        <Box sx={{ height: '100%', minHeight: 0 }}>
            <Routes>
                <Route index element={<MonitorOverview />} />
                <Route
                    path="pipr"
                    element={<Navigate to="/monitor/pipr/fed" replace />}
                />
                <Route path="pipr/:bank" element={<PiprPage />} />
                <Route path="*" element={<Navigate to="/monitor" replace />} />
            </Routes>
        </Box>
    );
}
